export default "__VITE_ASSET__Ca95aF8j__";